<template>
  <div class="relative bg-red  shadow" v-if="flashMessage">
    <div class="max-w-screen-xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
      <div class="pr-16 sm:text-center sm:px-16">
        <p class="font-medium text-white">
          {{ flashMessage }}
        </p>
      </div>
      <div
        class="absolute inset-y-0 right-0 pt-1 pr-1 flex items-start sm:pt-1 sm:pr-2 sm:items-start"
      >
        <button
          type="button"
          @click="$store.dispatch('dismissFlashMessage')"
          class="flex p-2 rounded-md hover:bg-green focus:outline-none focus:bg-indigo-500 transition ease-in-out duration-150"
          aria-label="Dismiss"
        >
          <svg
            class="h-6 w-6 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { auth } from "../utils/firebase";

export default {
  name: "FlashMessage",
  data() {
    return {
      showNotifications: true
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
      flashMessage: "flashMessage"
    }),
    displayName() {
      if (auth.currentUser) {
        return auth.currentUser.displayName;
      } else {
        return "Not logged in";
      }
    }
  },
  methods: {
    signOut() {
      auth.signOut();
    },
    dismissFlashMessage() {
      this.$store.dispatch("dismissFlashMessage");
    },
    hideNotificationMenu(e) {
      console.log(e);
      if (!this.$refs.notificationMenu.contains(e.target)) {
        this.showNotifications = false;
      }
    }
  }
};
</script>

<style scoped></style>
